var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("icon-container icon-container--" + _vm.variant),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('b-icon',{class:("icon icon--" + _vm.variant),attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }